
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/630deb8c952948e7d976a0dc5c3065c2.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 text-center">
        <div className="mb-4 md:mb-6">
          <span className="inline-block px-3 py-1.5 md:px-4 md:py-2 bg-teal-500/20 backdrop-blur-sm border border-teal-400/30 rounded-full text-teal-300 text-xs md:text-sm font-semibold">
            <span className="hidden md:inline">30년의 전문성과 실증된 성공 경험</span>
            <span className="md:hidden">30년 전문성 · 800+ 성공사례</span>
          </span>
        </div>
        
        <h1 className="font-serif text-4xl md:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight">
          U&I Partners
        </h1>
        
        <p className="text-base md:text-2xl text-gray-200 mb-8 md:mb-12 leading-relaxed max-w-3xl mx-auto px-2">
          <span className="hidden md:block">
            ISO 인증부터 경영 컨설팅까지, 기업의 생존과 성장을 위한<br />실전형 전략을 제시하는 전략적 파트너
          </span>
          <span className="md:hidden">
            ISO 인증 · 경영 컨설팅<br />기업 성장의 전략적 파트너
          </span>
        </p>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center px-4 md:px-0">
          <a
            href="#about"
            className="px-6 py-3.5 md:px-8 md:py-4 bg-teal-500 text-white font-semibold rounded-lg hover:bg-teal-600 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap inline-flex items-center justify-center text-sm md:text-base"
          >
            회사 소개 보기
          </a>
          <a
            href="#contact"
            className="px-6 py-3.5 md:px-8 md:py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/20 transition-all border border-white/30 cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2 text-sm md:text-base"
          >
            무료 상담 신청
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mt-12 md:mt-20 max-w-4xl mx-auto px-4 md:px-0">
          <div className="text-center bg-white/5 backdrop-blur-sm rounded-xl py-4 md:py-0 md:bg-transparent">
            <div className="text-2xl md:text-5xl font-bold text-white mb-1 md:mb-2">800+</div>
            <div className="text-gray-300 text-xs md:text-sm">성공 레퍼런스</div>
          </div>
          <div className="text-center bg-white/5 backdrop-blur-sm rounded-xl py-4 md:py-0 md:bg-transparent">
            <div className="text-2xl md:text-5xl font-bold text-white mb-1 md:mb-2">30년</div>
            <div className="text-gray-300 text-xs md:text-sm">현장 노하우</div>
          </div>
          <div className="text-center bg-white/5 backdrop-blur-sm rounded-xl py-4 md:py-0 md:bg-transparent">
            <div className="text-2xl md:text-5xl font-bold text-white mb-1 md:mb-2">100%</div>
            <div className="text-gray-300 text-xs md:text-sm">맞춤형 솔루션</div>
          </div>
          <div className="text-center bg-white/5 backdrop-blur-sm rounded-xl py-4 md:py-0 md:bg-transparent">
            <div className="text-2xl md:text-5xl font-bold text-white mb-1 md:mb-2">1위</div>
            <div className="text-gray-300 text-xs md:text-sm">고객 만족도</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 md:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl md:text-3xl"></i>
      </div>
    </section>
  );
}
